(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bjerve-degmeg-tilbud"] && !Shopify.designMode) return;
  try {
    /* Client gate: Shopify's page cache can serve a page rendered before the
     offer ended. After 2026-12-31 23:59:59 Europe/Oslo hide every offer
     element, including any a later section re-render inserts. A javascript tag
     cannot read Liquid, so this copies degmeg_slutt above (and the band in
     sections/bjerve-degmeg-kampanje.liquid copies it once more): move all
     three together. */
  var slutt = 1798757999;
  if (Date.now() / 1000 > slutt) {
    var stil = document.createElement('style');
    stil.textContent = '[data-bjerve-degmeg-slutt]{display:none!important}';
    document.head.appendChild(stil);
    document.querySelectorAll('[data-bjerve-degmeg-slutt]').forEach(function (element) {
      element.remove();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
